import React from "react";
import { Styles } from "./styles.js";
import BreadcrumbBox from "../../../components/common/Breadcrumb.jsx";
import { useLanguageDetector } from "../../../hooks/useLanguageDetector.js";
import Heading from "../../../components/shared/Heading.jsx";
import { Container } from "react-bootstrap";
import { Icon } from "@iconify/react";
import { colors } from "../../../components/common/element/elements.js";
import { useTranslation } from "react-i18next";
import EnglishData from "../../../data/dmu-english-exam/en.json";
import RussianData from "../../../data/dmu-english-exam/ru.json";
import UzbekData from "../../../data/dmu-english-exam/uz.json";

const DMUEnglishExam = () => {
  const [data] = useLanguageDetector(EnglishData, RussianData, UzbekData);
  const { t } = useTranslation();

  return (
    <Styles>
      <BreadcrumbBox
        title={data?.title}
        image="/assets/images/dmu_english_exam_banner.webp"
        centerTitle={true}
        externalLink="https://forms.office.com/r/ftG8X41u9B"
      />
      <Container>
        <section className="dmu-english-exam-section">
          <div className="info">
            <p className="pb-2">{data?.info?.par1}</p>
            <ul className="list-unstyled">
              {data?.info?.list.map((item, index) => (
                <li className="d-flex mb-3 item" key={index}>
                  <div>
                    <Icon
                      icon="ph:paper-plane-right-duotone"
                      fontSize={20}
                      color={colors.bg2}
                    />
                  </div>
                  <p className="ps-3">{item}</p>
                </li>
              ))}
            </ul>
            <p>{data?.info?.par2}</p>
          </div>

          <div className="structure">
            <Heading
              tag="h4"
              className="strategy-title"
              title={data?.structure?.title}
            />
            <p className="pb-2">{data?.structure?.par1}</p>
            <div className="structure-list">
              {data?.structure?.tests.slice(0, 2).map((item, index) => (
                <div key={index} className="structure-item">
                  <h5 className="mb-4">{item?.title}</h5>
                  <div>
                    {item?.details.map((detail, i) => (
                      <div key={i}>
                        <p>
                          <b>{detail?.title}:</b> {detail?.value}
                        </p>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
            <div className="structure-list">
              {data?.structure?.tests.slice(2, 4).map((item, index) => (
                <div key={index} className="structure-item">
                  <h5 className="mb-4">{item?.title}</h5>
                  <div>
                    {item?.details.map((detail, i) => (
                      <div key={i}>
                        <p>
                          <b>{detail?.title}:</b> {detail?.value}
                        </p>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="details">
            <div className="address">
              <p>
                <b>{data?.details?.address?.title}: </b>
                <a
                  href={data?.details?.address?.link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {data?.details?.address?.value}
                </a>
              </p>
              <p>
                <b>{data?.details?.mode?.title}: </b>
                {data?.details?.mode?.value}
              </p>
            </div>
            <Heading
              tag="h5"
              className="strategy-title"
              title={data?.details?.dates?.title}
            />
            <p className="pb-2">
              <b>{data?.details?.dates?.par1?.bold}</b>{" "}
              {data?.details?.dates?.par1?.span}
            </p>
            <table className="table table-bordered w-100">
              <thead>
                <tr className="text-center">
                  {data?.details?.dates?.table?.headers?.map(
                    (header, index) => (
                      <th scope="col" key={index}>
                        {header}
                      </th>
                    )
                  )}
                </tr>
              </thead>
              <tbody>
                {data?.details?.dates?.table?.rows?.map((row, index) => (
                  <tr key={index}>
                    {row?.map((cell, i) => (
                      <td key={i}>{cell}</td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
            <p>
              <b>{data?.details?.dates?.par2?.bold}</b>{" "}
              {data?.details?.dates?.par2?.span}
            </p>
          </div>

          <div className="notes pt-4">
            <Heading
              tag="h5"
              className="strategy-title"
              title={data?.notes?.title}
            />
            <p>{data?.notes?.par1}</p>
            <p>
              {data?.notes?.par2?.preLink}
              <a href={`mailto:${data?.notes?.par2?.link}`}>
                {data?.notes?.par2?.link}
              </a>
              {data?.notes?.par2?.postLink}
            </p>
          </div>

          <div className="guidelines pt-4">
            <Heading
              tag="h5"
              className="strategy-title"
              title={data?.guidelines?.title}
            />
            <p className="mb-4">
              <b>{data?.guidelines?.par1?.bold1}</b>{" "}
              {data?.guidelines?.par1?.span1}
              <b>{data?.guidelines?.par1?.bold2}</b>{" "}
              {data?.guidelines?.par1?.span2}
            </p>
            <h5>{data?.guidelines?.par2}</h5>
            <div className="py-5 d-flex justify-content-center">
              <a
                href="https://forms.office.com/r/ftG8X41u9B"
                target="_blank"
                rel="noopener noreferrer"
                className="register-button-link"
              >
                {t("Register now")}
              </a>
            </div>
          </div>
        </section>
      </Container>
    </Styles>
  );
};

export default DMUEnglishExam;
